import { css, html } from "@isceco/widget-library2/external/lit";
import SbfiReportingService from "./SbfiReportingService";
import FormComponent from "../../../../components/FormComponent";

export default class Reporting extends FormComponent {

  static PHONE_PATTERN_INTL_CH = '^(?:\\+\\d\\d|00\\d\\d|0)(?:\\s?\\d){9,15}$';
  static UUID_PATTERN =
    '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$';
  static YES_KEY = 'form.report.yes';
  static NO_KEY = 'form.report.no';
  static NOTICE_KEY = 'form.report.notice';

  constructor() {
    super();
    this._finanzenSubtotal = 0;
    this._finanzenTotal = 0;
    this._finanzenFoerderBetragTotal = 0;
  }

  get translationFile() {
    return './views/WBF/SBFI/Reporting/i18n.json';
  }

  connectedCallback() {
    super.connectedCallback();
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryString);
    this.referenzId = params.get('id') || '';
    this.reload();
  }

  get css() {
    return css`
      .form-elements isceco-card {
        margin-bottom: var(--isceco-space-300);
      }
      .gesuch-auswahl{
        margin-bottom: var(--isceco-space-200);
      }
      .gesuch-auswahl p{
        margin: 0;
      }
      .form-card {
        display: flex;
        flex-flow: column nowrap;
        gap: var(--isceco-space-200);
      }
      .cols {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
      .cols > * {
        flex: 1;
        min-width: 0;
      }
      @media (min-width: 768px) {
        .cols {
          flex-direction: row;
        }
      }
      .popup-wrapper {
        display: flex;
        align-items: center;
        gap: 0.1rem;
        margin-bottom: -2rem;
      }
    `;
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview';
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('page.title')}"></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form
        id="sbfi-report-form"
        include-disabled
        submit-button-text="${this.i18n.translate(submitKey)}"
        @submit="${e => this._submit(e)}"
      >
        <div slot="buttons">
          <isceco-button
            text="${this.i18n.translate('form.button.abort')}"
            @click="${() => this.abort()}"
            variant="secondary"
            .disabled="${!this.preview}"
          ></isceco-button>
        </div>
        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>
      </isceco-form>
    `;
  }

  getFormElements = () => {
    return html`
      ${this._renderRequest()}
      ${this._renderContactPerson()}
      ${this._renderOrtDauer()}
      ${this._renderfinanzen()}
      ${this._renderReporting()}
      ${this._renderRequirements()}
      ${this._renderEvaluation()}
      ${this._renderEnter()}
    `;
  };

  _renderRequest = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.report.request.title')}" class="form-card">
        <div class="gesuch-auswahl">
          <p>${this.i18n.translate('form.report.request.text')}</p>
          <p>${this.i18n.translate('form.report.request.text2')}</p>
        </div>
        <isceco-text-input
          label="${this.i18n.translate('form.report.request.select')}"
          help-text="${this.i18n.translate('form.report.request.select.help')}"
          name="referenz"
          .value=${this.referenzId}
          required
          pattern="${Reporting.UUID_PATTERN}"
          pattern-error-text="${this.i18n.translate('form.report.uuid.error')}"
          .readonly="${this.preview}"
        ></isceco-text-input>
      </isceco-card>
    `;
  };

  _renderContactPerson = () => {
    return html`
      <isceco-title text="${this.i18n.translate('form.report.kontaktperson')}"></isceco-title>
      <isceco-card class="form-card">
        <isceco-radio-group
          .value="${this.selectedContactChange}"
          name="kontaktpersonGeaendert"
          label="${this.i18n.translate('form.report.kontaktperson.change')}"
          .items="${[
            { value: 'true', name: this.i18n.translate(Reporting.YES_KEY) },
            { value: 'false', name: this.i18n.translate(Reporting.NO_KEY) }
          ]}"
          inline
          @change="${this._onContactChangeChanged}"
          .readonly="${this.preview}"
        ></isceco-radio-group>
      </isceco-card>
      ${this.selectedContactChange === 'true'
      ? this._renderContactPersonDetails()
      : ''}
    `;
  };

  _renderContactPersonDetails = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.title.report.kontaktperson')}" class="form-card">
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.report.kontaktperson.vorname')}"
                             name="kontaktperson.vorname"
                             .value="${this._getAttributeFromTokenParsed('given_name')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.report.kontaktperson.nachname')}"
                             name="kontaktperson.nachname"
                             .value="${this._getAttributeFromTokenParsed('family_name')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
        </div>
        <isceco-text-input
          label="${this.i18n.translate('form.report.kontaktperson.tel')}"
          name="kontaktperson.tel"
          required
          pattern="${Reporting.PHONE_PATTERN_INTL_CH}"
          pattern-error-text="${this.i18n.translate('form.report.phone.error')}"
          .readonly="${this.preview}"
        ></isceco-text-input>
        <isceco-text-input
          label="${this.i18n.translate('form.report.kontaktperson.email')}"
          name="kontaktperson.email"
          .value="${this._getAttributeFromTokenParsed('email')}"
          required
          type="email"
          pattern-error-text="${this.i18n.translate('form.report.email.error')}"
          .readonly="${this.preview}"
        ></isceco-text-input>
      </isceco-card>
    `;
  };

  _renderOrtDauer = () => {
    return html`
      <isceco-title text="${this.i18n.translate('form.report.actionsoverview')}"></isceco-title>
      <isceco-card text="${this.i18n.translate('form.report.actionsoverview.title')}" class="form-card">
        <div class="cols">
          <isceco-date-input
            label="${this.i18n.translate('form.report.actionsoverview.start')}"
            name="ortDauer.startdatumGeplant"
            required
            .readonly="${this.preview}"
            max="${this._today()}"
          ></isceco-date-input>
          <isceco-date-input
            label="${this.i18n.translate('form.report.actionsoverview.end')}"
            name="ortDauer.enddatumGeplant"
            required
            .readonly="${this.preview}"
            max="${this._today()}"
          ></isceco-date-input>
        </div>
        <isceco-number-input
          label="${this.i18n.translate('form.report.actionsoverview.groupcount')}"
          name="ortDauer.anzahlGruppen"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>
      </isceco-card>
    `;
  };

  _renderfinanzen = () => {
    return html`
      <isceco-card
        text="${this.i18n.translate('form.report.finanzen.title')}"
        class="form-card"
      >
        <p>${this.i18n.translate('form.report.finanzen.description')}</p>

        <div class="cols">
          <isceco-number-input
            label="${this.i18n.translate('form.report.finanzen.groupsize')}"
            name="finanzen.gruppengroesse"
            required
            .readonly="${this.preview}"
            @change="${this._onfinanzenChange}"
            min="3"
            maximum-fraction-digits="0"
          ></isceco-number-input>

          <isceco-number-input
            label="${this.i18n.translate('form.report.finanzen.lections')}"
            name="finanzen.lektionen"
            required
            .readonly="${this.preview}"
            @change="${this._onfinanzenChange}"
            min="20"
            max="40"
            maximum-fraction-digits="0"
          ></isceco-number-input>

          <isceco-text-input
            label="${this.i18n.translate('form.report.finanzen.total')}"
            name="finanzen.total"
            readonly="true"
          ></isceco-text-input>
        </div>

        <div class="popup-wrapper">
          <p>${this.i18n.translate('form.report.finanzen.notice')}</p>
          <isceco-popup direction="right">
            <i slot="wrapper" class="icon info circle"></i>
            <div slot="content">
              <span style="font-size: 0.9rem">
                ${this.i18n.translate('form.report.finanzen.notice.description')}
              </span>
            </div>
          </isceco-popup>
        </div>

        <isceco-checkbox
          name="finanzen.pauschaleAktiv"
          label="${this.i18n.translate(Reporting.YES_KEY)}"
          @change="${this._onFlatRateCheckboxChange}"
          .readonly="${this.preview}"
        ></isceco-checkbox>

        <div class="cols">
          <div class="empty-div"></div>

          <isceco-text-input
            label="${this.i18n.translate('form.report.finanzen.flatrate')}"
            name="finanzen.flatrate"
            readonly="true"
          ></isceco-text-input>

          <isceco-text-input
            label="${this.i18n.translate('form.report.finanzen.subtotal')}"
            name="finanzen.subtotal"
            readonly="true"
          ></isceco-text-input>
        </div>

        <div class="cols">
          <div class="empty-div"></div>

          <isceco-number-input
            label="${this.i18n.translate('form.report.finanzen.costeducationprovider')}"
            maximum-fraction-digits="2"
            name="finanzen.kostenBildungsanbietenden"
            required
            @change="${this._onfinanzenChange}"
            .readonly="${this.preview}"
          ></isceco-number-input>

          <isceco-text-input
            label="${this.i18n.translate('form.report.finanzen.fundingamount')}"
            name="finanzen.foerderbetragTotal"
            readonly="true"
          ></isceco-text-input>
        </div>

        <isceco-file-input
          label="${this.i18n.translate('form.report.finanzen.invoice.title')}"
          name="kostenBildungsanbietendenAttachments"
          required
          multiple
          maxfiles="5"
          maxsize="${this.fileMaxSize}"
          .fileInputService="${this.fileInputService}"
          .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

    `;
  };

  _renderReporting() {
    return html`
    <isceco-title text="${this.i18n.translate('form.report.title')}"></isceco-title>

    <isceco-card
      text="${this.i18n.translate('form.report.reporting.title')}"
      class="form-card"
    >
      <div class="cols">
        <isceco-number-input
          label="${this.i18n.translate('form.report.reporting.participants.total')}"
          name="teilnehmer.total"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>

        <isceco-number-input
          label="${this.i18n.translate('form.report.reporting.participants.over.20')}"
          name="teilnehmer.ueber20"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>
      </div>

      <div class="cols">
        <isceco-number-input
          label="${this.i18n.translate('form.report.reporting.participants.women')}"
          name="teilnehmer.frauen"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>

        <isceco-number-input
          label="${this.i18n.translate('form.report.reporting.participants.over.40')}"
          name="teilnehmer.ueber40"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>
      </div>

      <div class="cols">
        <isceco-number-input
          label="${this.i18n.translate('form.report.reporting.participants.without.qualification')}"
          name="teilnehmer.ohneAbschluss"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>

        <isceco-number-input
          label="${this.i18n.translate('form.report.reporting.participants.over.50')}"
          name="teilnehmer.ueber50"
          required
          .readonly="${this.preview}"
        ></isceco-number-input>
      </div>

      <isceco-file-input
        label="${this.i18n.translate('form.report.reporting.participantsupload')}"
        name="teilnehmerbescheinigungAttachments"
        required
        multiple
        maxfiles="5"
        maxsize="${this.fileMaxSize}"
        .fileInputService="${this.fileInputService}"
        .disabled="${this.preview}"
      ></isceco-file-input>
    </isceco-card>
  `;
  }


  _renderRequirements() {
    return html`
    <isceco-card class="form-card">
      <h3 style="margin: 0">
        ${this.i18n.translate('form.report.requirements.title')}
      </h3>

      <isceco-radio-group
        value="true"
        name="massnahme.frage1"
        label="${this.i18n.translate('form.report.requirements.question.1')}"
        required
        .items="${[
          {
            value: 'true',
            name: this.i18n.translate(Reporting.YES_KEY)
          },
          {
            value: 'false',
            name: this.i18n.translate(Reporting.NO_KEY)
          }
        ]}"
        .readonly="${this.preview}"
      ></isceco-radio-group>

      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="massnahme.frage1Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>

      <isceco-radio-group
        value="true"
        name="massnahme.frage2"
        label="${this.i18n.translate('form.report.requirements.question.2')}"
        required
        .items="${[
          {
            value: 'true',
            name: this.i18n.translate(Reporting.YES_KEY)
          },
          {
            value: 'false',
            name: this.i18n.translate(Reporting.NO_KEY)
          }
        ]}"
        .readonly="${this.preview}"
      ></isceco-radio-group>

      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="massnahme.frage2Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>

      <isceco-radio-group
        value="true"
        name="massnahme.frage3"
        label="${this.i18n.translate('form.report.requirements.question.3')}"
        required
        .items="${[
          {
            value: 'true',
            name: this.i18n.translate(Reporting.YES_KEY)
          },
          {
            value: 'false',
            name: this.i18n.translate(Reporting.NO_KEY)
          }
        ]}"
        .readonly="${this.preview}"
      ></isceco-radio-group>

      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="massnahme.frage3Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>

      <isceco-radio-group
        value="true"
        name="massnahme.frage4"
        label="${this.i18n.translate('form.report.requirements.question.4')}"
        required
        .items="${[
          {
            value: 'true',
            name: this.i18n.translate(Reporting.YES_KEY)
          },
          {
            value: 'false',
            name: this.i18n.translate(Reporting.NO_KEY)
          }
        ]}"
        .readonly="${this.preview}"
      ></isceco-radio-group>

      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="massnahme.frage4Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>

      <isceco-radio-group
        value="true"
        name="massnahme.frage5"
        label="${this.i18n.translate('form.report.requirements.question.5')}"
        required
        .items="${[
          {
            value: 'true',
            name: this.i18n.translate(Reporting.YES_KEY)
          },
          {
            value: 'false',
            name: this.i18n.translate(Reporting.NO_KEY)
          }
        ]}"
        .readonly="${this.preview}"
      ></isceco-radio-group>

      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="massnahme.frage5Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>
    </isceco-card>
  `;
  }



  _renderEvaluation() {
    return html`
    <isceco-card class="form-card">
      <h3 style="margin: 0">
        ${this.i18n.translate('form.report.evaluation.title')}
      </h3>

      <isceco-radio-group
        value="true"
        name="evaluation.frage1"
        label="${this.i18n.translate('form.report.evaluation.question.1')}"
        required
        .items="${[
          {
            value: 'true',
            name: this.i18n.translate(Reporting.YES_KEY)
          },
          {
            value: 'false',
            name: this.i18n.translate(Reporting.NO_KEY)
          }
        ]}"
        .readonly="${this.preview}"
      ></isceco-radio-group>

      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="evaluation.frage1Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>

      <p><b>${this.i18n.translate('form.report.evaluation.question.2')}</b></p>
      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="evaluation.frage2Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>

      <p><b>${this.i18n.translate('form.report.evaluation.question.3')}</b></p>
      <isceco-textarea
        label="${this.i18n.translate(Reporting.NOTICE_KEY)}"
        name="evaluation.frage3Text"
        rows="4"
        .readonly="${this.preview}"
      ></isceco-textarea>
    </isceco-card>
  `;
  }


  _renderEnter() {
    return html`
    <isceco-title
      text="${this.i18n.translate('form.report.enter.title')}"
    ></isceco-title>

    <isceco-card class="form-card">
      <h4 style="margin: 0">
        ${this.i18n.translate('form.report.enter.email.title')}
      </h4>

      <p>
        ${this.i18n.translate('form.report.enter.email.information')}
      </p>

      <div class="cols">
        <isceco-text-input
          label="${this.i18n.translate('form.report.enter.email')}"
          name="zustellung.email"
          .value="${this._getAttributeFromTokenParsed('email')}"
          type="email"
          pattern-error-text="${this.i18n.translate('form.report.email.error')}"
          .readonly="${this.preview}"
        ></isceco-text-input>

        <div class="empty-div"></div>
      </div>
    </isceco-card>
  `;
  }


  _submit = event => {
    if (!this.preview) {
      this.preview = true;
      this.render();
      return;
    }

    const formValues = event.detail;

    if (formValues.finanzen) {
      formValues.finanzen.pauschaleAktiv =
        !!formValues.finanzen.pauschaleAktiv;

      formValues.finanzen.total = this._finanzenTotal;
      formValues.finanzen.subtotal = this._finanzenSubtotal;
      formValues.finanzen.foerderbetragTotal =
        this._finanzenFoerderBetragTotal;
    }

    new SbfiReportingService().submit(event.detail, event.target);
  };


  _onfinanzenChange = () => {

    const groupsize = this._getGroupSize();

    const lections = this._getLections();

    const flatRate = this._getFlatRate();

    const costEducationProvider = this._getCostEducationProvider();

    const total = groupsize * lections * 15;
    const subtotal = total + flatRate;

    this._finanzenSubtotal = subtotal;
    this._finanzenTotal = total;

    const fundingAmount = this._calculateFunding(costEducationProvider, subtotal);

    this._finanzenFoerderBetragTotal = fundingAmount;

    this._applyFinanzenValues(total, subtotal, fundingAmount);
  };

  _getGroupSize() {
    return parseFloat(
      this.querySelector('[name="finanzen.gruppengroesse"]')?.value || 0
    );
  }

  _getLections() {
    return parseFloat(
      this.querySelector('[name="finanzen.lektionen"]')?.value || 0
    );
  }

  _getFlatRate() {
    return parseFloat(
      (this.querySelector('[name="finanzen.flatrate"]')?.value || '')
        .replace(/\D/g, '')
    ) || 0;
  }
  _calculateFunding(costEducationProvider, subtotal) {
    let fundingAmount;

    if (costEducationProvider < subtotal) {
      fundingAmount = costEducationProvider;
    } else {
      fundingAmount = subtotal;
    }

    return fundingAmount;
  }

  _getCostEducationProvider() {
    return parseFloat(
      (this.querySelector('[name="finanzen.kostenBildungsanbietenden"]')?.value || '')
        .replace(/\D/g, '')
    ) || 0;
  }
  _applyFinanzenValues(total, subtotal, fundingAmount) {

    const totalInput = this.querySelector('[name="finanzen.total"]');
    const subtotalInput = this.querySelector('[name="finanzen.subtotal"]');
    const fundingAmountInput =
      this.querySelector('[name="finanzen.foerderbetragTotal"]');

    if (totalInput) {
      totalInput.value = this._formatCH(total);
    }

    if (subtotalInput) {
      subtotalInput.value = this._formatCH(subtotal);
    }

    if (fundingAmountInput) {
      fundingAmountInput.value = this._formatCH(fundingAmount);
    }
  }


  _onFlatRateCheckboxChange = e => {
    const checked = !!e.detail?.value;
    const flatRateValue = checked ? 3000 : 0;

    const flatRateInput =
      this.querySelector('[name="finanzen.flatrate"]');

    if (flatRateInput) {
      flatRateInput.value = this._formatCH(flatRateValue);
    }

    this._onfinanzenChange();
  };
  _onContactChangeChanged = e => {
    this.selectedContactChange = e.detail.value;
    this.render();
  };

  _formatCH(val) {
    if (!val || isNaN(val)){
      return 'CHF 0';
    }
    return 'CHF ' + val.toLocaleString('de-CH');
  }

  _today() {
    return new Date().toISOString().split('T')[0];
  }
}

customElements.define('eform-sbfi-reporting', Reporting);
